export const isValidSouthAfricanPhone = (phoneNumber) => {
  if (!phoneNumber) return false;
  const cleaned = phoneNumber.replace(/\s/g, ''); // remove spaces
  const saMobileRegex = /^0[6-8][0-9]{8}$/;
  return saMobileRegex.test(cleaned);
};

export const formatPhoneForDisplay = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\s/g, '');
  if (cleaned.length === 10) {
    return `${cleaned.slice(0,3)} ${cleaned.slice(3,6)} ${cleaned.slice(6)}`;
  }
  return cleaned;
};
